
<div id="page-content" class="inicio" id="remessas">
  <div class="row">
    <div class="col-sm-10 col-sm-offset-1">
      <h3 *ngIf="!qtdBoletosSemRemessa && !error">Você não tem itens pendentes</h3>
      <h3 *ngIf="qtdBoletosSemRemessa > 0 && qtdBoletosSemRemessa === 1">Você tem <span class="qtd-item-remessa">1 item</span> pendente! <span class="alert-remessa-azul">Gere</span> uma nova <span class="alert-remessa-azul">remessa.</span></h3>
      <h3 *ngIf="qtdBoletosSemRemessa > 0 && qtdBoletosSemRemessa !== 1">Você tem <span class="qtd-item-remessa">{{qtdBoletosSemRemessa}} itens</span> pendentes! <span class="alert-remessa-azul">Gere</span> uma nova <span class="alert-remessa-azul">remessa.</span></h3>
      <div class="pull-right"  *ngIf="qtdBoletosSemRemessa > 0">
        <div *ngIf="cedente && cedentes.length > 1" class="dropdown">
          <label>Cedente</label>
          <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ cedente.Descricao }}<span class="caret"></span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
            <li (click)="selectCedente(cedente)" *ngFor="let cedente of cedentes"><a>{{ cedente.Descricao }}</a></li>
          </ul>
        </div>
        <button (click)="gerarRemessas()" class="btn btn-registrar mt-10 mb-30">Gerar Remessa</button>
      </div>
      <div *ngIf="!loaded && !error" class="container-loading">
        <div class="btn btn-registrar loading"></div>
      </div>
      <div class="col-md-10 col-md-offset-1" *ngIf="error">
        <span class="error">Nenhuma informação disponível no momento</span>
        <span class="error">Tente novamente mais tarde</span>
      </div>
      <table id="master-detail-table-remessa" style="width: 100%"></table>
    </div>
  </div>
</div>
